// 탈퇴 사유 — 웹(app/mypage/settings)과 앱(MY 탭)이 같은 목록을 쓴다.
// 한쪽만 고치면 익명 통계가 두 벌로 갈라져 집계가 무의미해지므로 여기가 단일 출처다.

export const WITHDRAW_REASONS = [
  '원하는 기능이 없어요',
  '사이트 사용이 불편해요',
  '커뮤니티 분위기가 맞지 않아요',
  '활동이 적어서/바빠서',
  '개인정보/보안이 걱정돼요',
  '다른 서비스로 이동해요',
] as const;

export type WithdrawReason = (typeof WITHDRAW_REASONS)[number];

/**
 * 선택 사유 + 주관식을 서버로 보낼 형태로 정규화한다.
 *
 * `delete_my_account(p_reasons, p_custom_reason)`가 받는 계약:
 *   - reasons: 빈 배열이면 서버가 ['무응답']으로 바꾼다. 여기서도 같은 값을 맞춰 보낸다.
 *   - custom_reason: 공백만 있으면 null (빈 문자열 행이 쌓이지 않게)
 *
 * 🔑 주관식을 적었으면 '기타'를 사유 목록에도 넣는다 — 안 넣으면 집계 시
 *    "주관식만 적은 사람"이 어느 항목에도 안 잡혀 사라진다.
 */
export function normalizeWithdrawInput(
  selected: readonly string[],
  customReason: string,
): { reasons: string[]; customReason: string | null } {
  const custom = (customReason || '').trim();
  const reasons = [...selected];
  if (custom && !reasons.includes('기타')) reasons.push('기타');
  return {
    reasons: reasons.length ? reasons : ['무응답'],
    customReason: custom || null,
  };
}
